var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheck2 = function SvgCheck2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#89c958",
    d: "M3.9 10.5c-.3 0-.5-.1-.7-.3L.3 7.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.2 2.2 6.4-6.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-7.1 7c-.2.2-.4.3-.7.3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck2);
export default ForwardRef;